export default __webpack_public_path__ + "static/media/Copyright_Mini.27607b3a.svg";